import { toast } from "react-toastify";
import compareObjects from "../compare/compareObjects";

const put = async ({
  actionFetch,
  data,
  urlMainEntity,
  datasAreValid,
  setPreventDraftig,
  fields,
  editingRelatedEntity,
  language,
  calType,
  notEvUrl,
  forceLtr,
  isProcessual,
  preventSuccessToast,
  action,
  isTheFirstManipulateReq = true,
  noMiddleUrl,
  noUpdate,
  noFields,
}) => {
  let wasSuccessFull;
  let fetchReqSent = false;

  if (editingRelatedEntity && editingRelatedEntity !== data?.id) {
    toast.error(forceLtr ? "Close editing related entity" : "ابتدا از تغییر دیتا دیگر خارج شوید");
  } else if (datasAreValid === false) {
    toast.error(forceLtr ? "Fix the form bugs first" : "ابتدا فیلدهای اشتباه را تصحیح کنید");
  } else {
    const finalizedData = action
      ? {
          updatingObject: data,
          action,
        }
      : data;
    if ((action && isProcessual) || fields) {
      if (!isTheFirstManipulateReq) {
        await new Promise((resolve) => setTimeout(resolve, 1100));
      }
      const result = await actionFetch({
        method: "PUT",
        url: notEvUrl
          ? notEvUrl
          : `${isProcessual ? "processual/" : ""}${noUpdate ? "" : "update/"}${urlMainEntity}${
              noFields ? "" : "?fields="
            }${noFields ? "" : fields}${action && isProcessual ? `${fields ? ",state" : "state"}` : ""}`,
        body: finalizedData,
        language,
        calType,
        notEV: notEvUrl ? true : null,
        noMiddleUrl: noMiddleUrl,
      });
      fetchReqSent = true;
      if (result.resIsOk && result.response?.message === "commands done!") {
        if (setPreventDraftig) {
          setPreventDraftig(true);
        }
        if (!preventSuccessToast) {
          toast.success(forceLtr ? "Data successfully updated" : "اطلاعات با موفقیت به روز رسانی شد");
        }
        wasSuccessFull = true;
      } else if (result.response?.message?.toLowerCase()?.includes("duplicate")) {
        toast.error(forceLtr ? "Record already exists!" : "اطلاعات وارد شده تکراری می باشد");
      } else if (result.response?.message?.toLowerCase()?.includes("you don't have access")) {
        toast.error(forceLtr ? result.response?.message : "شما دسترسی انجام این عملیات را ندارید");
      } else {
        wasSuccessFull = false;
        toast.error(forceLtr ? "your request faced a problem!" : "خطا در به روز رسانی اطلاعات");
      }
    } else {
      console.log(`no fields changed for ${urlMainEntity} so no request sent`);
    }
  }

  return { wasSuccessFull, fetchReqSent };
};

export default put;
